import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Grid } from '@mui/material';
import { DateSelector } from '../Date';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { REDUX_KEY } from '../../redux/constants';
import { setStartDate } from '../../redux/features/campaignDetail/campaignDetailSlice';
import { setEndDate } from '../../redux/features/campaignDetail/campaignDetailSlice';
import { TooltipBubble } from '../TooltipBubble';
import styled from 'styled-components';
import BasicGapContainer from './BasicGapContainer';

const CampaignLength = () => {
  const dispatch = useAppDispatch();
  const { startDate, endDate } = useAppSelector(
    (state: RootState) => state.detail[REDUX_KEY.CAMPAIGN_LENGTH]
  );

  const handleStartDateChange = (date: string | undefined) => {
    if (date && isDateInPast(new Date(date))) {
      date = undefined;
    }

    const updatedDate = setStartDate({ date });
    dispatch(updatedDate);
  };

  const handleEndDateChange = (date: string | undefined) => {
    if (date && isDateInPast(new Date(date))) {
      date = undefined;
    }

    const updatedDate = setEndDate({ date });
    dispatch(updatedDate);
  };

  const isDateInPast = (date: Date): boolean => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    return date < now;
  };

  return (
    <BasicGapContainer>
      <h3>
        Campaign Dates
        <TooltipBubble title="Select length of campaign" />
      </h3>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1 }}>
          <Grid item xs={6}>
            <DateSelector
              label="Campaign Start Date"
              value={startDate}
              onChange={handleStartDateChange}
            />
          </Grid>
          <Grid item xs={6}>
            <DateSelector
              label="Campaign End Date"
              value={endDate}
              onChange={handleEndDateChange}
              minDate={startDate}
            />
          </Grid>
        </Grid>
      </LocalizationProvider>
    </BasicGapContainer>
  );
};

export default CampaignLength;
